<template>
  <div class="not-found-container">
    <h1>404</h1>
    <h2>Página No Encontrada</h2>
    <p>Lo sentimos, la página que estás buscando no existe o ha sido movida.</p>
  </div>
</template>

<script>
export default {
  name: 'PaginaNoEncontrada'
}
</script>

<style scoped>
.not-found-container {
  height: 100vh;
  text-align: center;
  padding: 50px 20px;
  max-width: 600px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

h1 {
  font-size: 6rem;
  margin: 0;
  color: #e74c3c;
}

h2 {
  font-size: 2rem;
  margin-top: 0;
}

p {
  margin-bottom: 30px;
  font-size: 1.2rem;
  color: #555;
}

.home-link {
  display: inline-block;
  background-color: #3498db;
  color: white;
  padding: 10px 20px;
  text-decoration: none;
  border-radius: 4px;
  font-weight: bold;
}

.home-link:hover {
  background-color: #2980b9;
}
</style>